export default __webpack_public_path__ + "static/media/calculator-round.c6bd505f.svg";